export default __webpack_public_path__ + "static/media/location.f3cd606f.png";